import React from "react";

const Benefits = () => {
  return (
    <div className="mvs-benefits-wrapper">
      <h1>
        Benefits of <span>Machine</span> Vision Solution
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Reduced costs by minimizing human error and labor costs</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Enhanced quality control and consistency in production</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Increased production speed with real-time inspection</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>
              Scalable solutions adaptable to various production environments
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
